import { Component } from "react";
import Utils from "../../Utils";
import { Container, Row, FormGroup, Button, Label, Input } from 'reactstrap';

export class AdminTermsCondiciones extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nombre: "documento.pdf",
            version: 1.00,
            rol: props.rol
        };
    }

    componentDidMount() {
        this.getInfo();
    }

    async getInfo() {
        await Utils.documentoInfo()
            .then(data => {
                this.setState({ nombre: data.data.nombre, version: data.data.nroVersion })
            });
    }

    async setDocumento(elemento) {
        elemento.disabled = true;
        elemento.textContent = "Actualizando";
        const formData = new FormData();
        formData.append("file", elemento.form.elements[0].files[0]);
        if (elemento.form.elements[0].files.length == 0) {
            alert("No hay archivos cargados");
            elemento.disabled = false;
            elemento.textContent = "Actualizar";
            return;
        }
        if ( this.state.version >= Number(elemento.form.elements[1].value) ) {
            alert("La version ingresada debe ser superior a la actual");
            elemento.disabled = false;
            elemento.textContent = "Actualizar";
            return;
        }
       
        await Utils.setDocumento(formData,elemento.form.elements[1].value)
            .then(data => {
                let d = data.status;
                if (d === 200) {
                    alert(data.data)
                    this.getInfo();
                }
                else {
                    alert("Error: " + data.data)
                }
                elemento.disabled = true;
                elemento.textContent = "Actualizar";
            });


    }

    render() {
        return (
            <Container>
                <Row>
                    <div className="col-12 tyc">
                        <h5>Terminos y condiciones:</h5>
                        <Row className="tyctable">
                            <div className="col-3">
                                <a href="/api/Documento" target="_blank"><img src="/pdf-icon.png" width="20px" alt="PDF" />{this.state.nombre}</a>
                            </div>
                            <div className="col-3">
                                V: {this.state.version}
                            </div>
                            {this.state.rol === "A" ?
                            <form className="col-6" id="tycForm">
                                <Row>
                                    <div className="col-7">
                                        <FormGroup>
                                            <Label for="fileIn">
                                                File
                                            </Label>
                                            <Input id="fileIn" name="file" type="file" accept="application/pdf" />
                                        </FormGroup>
                                    </div>
                                    <div className="col-2">
                                        <FormGroup>
                                            <Label for="versionIn">
                                                Version
                                            </Label>
                                            <Input id="versionIn" name="version" type="number" step="0.01" placeholder="0.00" pattern="\d+(\.\d{0, 2})?" autocomplete="off" />
                                        </FormGroup>
                                    </div>
                                    <div className="col-2">
                                        <Button type="button" onClick={(e) => this.setDocumento(e.target)}>
                                            Actualizar
                                        </Button>
                                    </div>
                                </Row>
                            </form> : null
                            }
                        </Row>
                    </div>
                </Row>
            </Container>
        );
    }
}